import { CameraDetail } from '@hakimo-ui/hakimo/types';
import { LiveSection } from './LiveSection';
import { OverviewDetails } from './OverviewDetails';

interface Props {
  camera: CameraDetail;
}

export function CameraOverview(props: Props) {
  const { camera } = props;

  return (
    <div className="flex flex-col gap-6">
      <LiveSection camera={camera} />
      <OverviewDetails camera={camera} />
    </div>
  );
}

export default CameraOverview;
